import React from "react";

export default function ControlsContainer({ children }) {
  return <div className="mb-5">{children}</div>;
}
